import { IntegrationFeatureWebhook } from "../../index";
import { IntegrationFeatureOauth } from "../../index";


abstract class IntegrationFeature {

	static fromJson(json: Record<string, unknown>): IntegrationFeature {
		const type = typeof json.type === "string" ? json.type : "";
		if (type === IntegrationFeatureWebhook.type) {
			return IntegrationFeatureWebhook.fromJson(json);
		} else if (type === IntegrationFeatureOauth.type) {
			return IntegrationFeatureOauth.fromJson(json);
		}
		throw new Error("Unknown IntegrationFeature");
	}

	static get type(): string {
		throw new Error("Not implemented - subclass must override");
	}

	abstract get id(): string;

	abstract toJson(): Record<string, unknown>;
}

export { IntegrationFeature };
